var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNuggetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 219,
    viewBox: "0 0 206 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.79 119.62C84.0467 119.62 90.74 112.927 90.74 104.67C90.74 96.4134 84.0467 89.72 75.79 89.72C67.5334 89.72 60.84 96.4134 60.84 104.67C60.84 112.927 67.5334 119.62 75.79 119.62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.6 119.62C140.857 119.62 147.55 112.927 147.55 104.67C147.55 96.4134 140.857 89.72 132.6 89.72C124.343 89.72 117.65 96.4134 117.65 104.67C117.65 112.927 124.343 119.62 132.6 119.62Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.45 32.91V0.25H124.55V30.84H82.6901V0.25H52.7901V32.68C23.1201 39.58 0.810059 66.03 0.810059 98V115.71C0.810059 132.96 7.48006 148.83 18.2901 160.79C30.4801 174.36 48.1901 182.64 67.7401 182.64H83.8401L84.0701 218.75L136.28 182.64H138.12C174.92 182.64 205.05 152.51 205.05 115.71V98C205.05 66.49 183.43 40.27 154.45 32.91ZM175.15 115.71C175.15 136.18 158.59 152.74 138.12 152.74H127.08L84.5301 182.18V152.74H84.0701H67.7401C65.9001 152.74 64.2901 152.51 62.4501 152.28C44.5101 149.75 30.7101 134.34 30.7101 115.71V98C30.7101 77.53 47.2701 60.97 67.7401 60.97H138.12C158.59 60.97 175.15 77.53 175.15 98V115.71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuggetIcon);
export default __webpack_public_path__ + "static/media/NuggetIcon.272c856e6fca2b4a9581eb894688b2ae.svg";
export { ForwardRef as ReactComponent };